module.exports = __webpack_public_path__ + "static/media/view0006.5707de5a.png";